import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, sub, dark = false, className = "" }) => (
    <div className={className}>
        <Reveal>
            <p className={dark ? "eyebrow-dark" : "eyebrow"}>{eyebrow}</p>
            <div className="gold-rule mt-5" />
            <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl mt-6 leading-[1.08] tracking-tight ${dark ? "text-white" : "text-[#20242B]"}`}>
                {title}
            </h2>
            {sub ? (
                <p className={`text-base sm:text-lg leading-relaxed mt-5 max-w-2xl ${dark ? "text-white/60" : "text-[#737985]"}`}>{sub}</p>
            ) : null}
        </Reveal>
    </div>
);
